// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S54Xr","submit":"styles_submit__26ON9","title":"styles_title__qgv5x"};